import { EXERCISE_LOG_SUMMARIES_KEY } from '../../exercise-log-summaries/constants'

const EXERCISE_LOGS_ACTION = {}

const EXERCISE_LOGS_ANALYTICS_EVENT = {}

const EXERCISE_LOGS_DOMAIN = 'exerciseLogs'

const EXERCISE_LOGS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data',
  EXERCISE_ID_MAP: 'exerciseIdMap'
}

const EXERCISE_LOGS_PATH = {
  ALL: `${EXERCISE_LOGS_DOMAIN}.${EXERCISE_LOGS_KEY.ALL}`,
  CURRENT: `${EXERCISE_LOGS_DOMAIN}.${EXERCISE_LOGS_KEY.CURRENT}`,
  DATA: `${EXERCISE_LOGS_DOMAIN}.${EXERCISE_LOGS_KEY.DATA}`,
  EXERCISE_ID_MAP: `${EXERCISE_LOGS_DOMAIN}.${EXERCISE_LOGS_KEY.EXERCISE_ID_MAP}`
}

const EXERCISE_LOGS_STATE = {
  [EXERCISE_LOGS_KEY.ALL]: {
    data: [],
    status: null
  },
  [EXERCISE_LOGS_KEY.CURRENT]: null,
  [EXERCISE_LOGS_KEY.DATA]: {},
  [EXERCISE_LOG_SUMMARIES_KEY.EXERCISE_ID_MAP]: {}
}

export {
  EXERCISE_LOGS_KEY,
  EXERCISE_LOGS_ACTION,
  EXERCISE_LOGS_DOMAIN,
  EXERCISE_LOGS_PATH,
  EXERCISE_LOGS_STATE,
  EXERCISE_LOGS_ANALYTICS_EVENT
}
